import { render } from "./PrenatalChartsTab.vue?vue&type=template&id=24cd156c&scoped=true"
import script from "./PrenatalChartsTab.vue?vue&type=script&lang=js"
export * from "./PrenatalChartsTab.vue?vue&type=script&lang=js"

import "./PrenatalChartsTab.vue?vue&type=style&index=0&id=24cd156c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cd156c"]])

export default __exports__